import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import { isLandingPageUrl, extractLandingPageSlug } from '../utils/landingPageUrls';

const CatchAllRouteHandler: React.FC = () => {
  const location = useLocation();
  
  // Check if this is a landing page URL
  if (isLandingPageUrl(location.pathname)) {
    const slug = extractLandingPageSlug(location.pathname);
    
    if (slug && slug !== '') {
      return <LandingPage slug={slug} />;
    }
  }
  
  // Not a landing page URL, redirect to homepage
  return <Navigate to="/" replace />;
};

export default CatchAllRouteHandler;